import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "sidebar" }
const _hoisted_3 = {
  key: 0,
  class: "sidebar__body"
}
const _hoisted_4 = {
  key: 1,
  class: "sidebar__body"
}
const _hoisted_5 = {
  key: 2,
  class: "sidebar__body"
}
const _hoisted_6 = { class: "form-wrapper" }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { class: "control" }
const _hoisted_9 = { class: "field" }
const _hoisted_10 = { class: "control" }
const _hoisted_11 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_12 = { class: "field" }
const _hoisted_13 = { class: "control" }
const _hoisted_14 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_15 = { class: "field" }
const _hoisted_16 = { class: "control" }
const _hoisted_17 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_18 = { class: "field" }
const _hoisted_19 = { class: "control" }
const _hoisted_20 = {
  key: 0,
  class: "help is-danger"
}

import { workspacesApi } from '@/workspaces/workspaces';
import { RegisterUserViewModel } from '@/workspaces/models/request/registerUserViewModel';
import authService from '@/authentication/authentication.service';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import jwt_decode from 'jwt-decode';
import { InviteToken } from '@/features/registration/models/inviteToken';
import { onBeforeMount, ref } from 'vue';
import { minLength, required, sameAs, maxLength } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'Register',
  setup(__props) {

const containsLetters = (value: string) => /(.*[a-z].*)/.test(value) && /(.*[A-Z].*)/.test(value);
const containsNumbers = (value: string) => /\d/.test(value);

const email = ref('');
const firstName = ref('');
const lastName = ref('');
const password = ref('');
const confirmPassword = ref('');
const loading = ref(true);
const isTokenValid = ref(false);
const tokenErrorMsg = ref('');
const token = ref('');

const validations = {
  firstName: {
    required,
    maxLength: maxLength(64),
  },
  lastName: {
    required,
    maxLength: maxLength(64),
  },
  password: {
    required,
    minLength: minLength(8),
    containsLetters,
    containsNumbers,
  },
  confirmPassword: {
    required,
    sameAs: sameAs('password'),
  },
};

const $v = useVuelidate(validations, { firstName, lastName, password, confirmPassword });
const route = useRoute();

onBeforeMount(async () => {
  token.value = <string>route.params.token;
  const validateResponse = await workspacesApi.validateRegistrationToken(token.value);
  loading.value = false;
  if (validateResponse.isValid) {
    isTokenValid.value = true;
    tokenErrorMsg.value = '';
    email.value = validateResponse.email;
  } else {
    isTokenValid.value = false;
    tokenErrorMsg.value = validateResponse.errorMsg;
  }
});

async function register(): Promise<void> {
  const user: RegisterUserViewModel = {
    email: email.value,
    firstName: firstName.value,
    lastName: lastName.value,
    password: password.value,
    tokenString: token.value,
  };
  try {
    await workspacesApi.registerUser(user);
    const token: InviteToken = jwt_decode(user.tokenString);
    if (token.loginUrl) {
      window.location.assign(token.loginUrl);
    } else {
      authService.login();
    }
  } catch (err: any) {
    tokenErrorMsg.value = err.message;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_n_loading_spinner = _resolveComponent("n-loading-spinner")!
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[25] || (_cache[25] = _createElementVNode("link", {
      href: "https://fonts.googleapis.com/css?family=Lato:400,700",
      rel: "stylesheet"
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "sidebar__header" }, [
        _createElementVNode("div", { class: "connect-logo" })
      ], -1)),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_n_loading_spinner)
          ]))
        : _createCommentVNode("", true),
      (!loading.value && !isTokenValid.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "sidebar-title" }, "Registration Error", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "sidebar-subtitle" }, "Something has gone wrong!", -1)),
            _createElementVNode("div", null, _toDisplayString(tokenErrorMsg.value), 1)
          ]))
        : _createCommentVNode("", true),
      (!loading.value && isTokenValid.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "sidebar-title" }, "Register", -1)),
            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "sidebar-subtitle" }, "Enter your account details to complete your registration", -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "label" }, "Email", -1)),
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    class: "input",
                    type: "email",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                    placeholder: "Enter your email address",
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, email.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "label" }, "First Name", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    class: "input",
                    type: "text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((firstName).value = $event)),
                    onBlur: _cache[2] || (_cache[2] = ($event: any) => (_unref($v).firstName.$touch())),
                    placeholder: "Enter your first name"
                  }, null, 544), [
                    [
                      _vModelText,
                      firstName.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                (_unref($v).firstName.$invalid && _unref($v).firstName.$dirty)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Please enter your first name "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[13] || (_cache[13] = _createElementVNode("label", { class: "label" }, "Last Name", -1)),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    class: "input",
                    type: "text",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((lastName).value = $event)),
                    onBlur: _cache[4] || (_cache[4] = ($event: any) => (_unref($v).lastName.$touch())),
                    placeholder: "Enter your last name"
                  }, null, 544), [
                    [
                      _vModelText,
                      lastName.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                (_unref($v).lastName.$invalid && _unref($v).lastName.$dirty)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, "Please enter your last name"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "label" }, "Password", -1)),
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    class: "input",
                    type: "password",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((password).value = $event)),
                    onBlur: _cache[6] || (_cache[6] = ($event: any) => (_unref($v).password.$touch())),
                    placeholder: "Enter your password"
                  }, null, 544), [
                    [
                      _vModelText,
                      password.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                (_unref($v).password.$invalid && _unref($v).password.$dirty)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, "Password not sufficient"))
                  : _createCommentVNode("", true),
                _cache[15] || (_cache[15] = _createElementVNode("p", { class: "help" }, "Must be at least 8 characters long", -1)),
                _cache[16] || (_cache[16] = _createElementVNode("p", { class: "help" }, "Must contain a mixture of uppercase and lowercase letters", -1)),
                _cache[17] || (_cache[17] = _createElementVNode("p", { class: "help" }, "Must contain at least 1 number", -1))
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "label" }, "Confirm Password", -1)),
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    class: "input",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((confirmPassword).value = $event)),
                    type: "password",
                    onBlur: _cache[8] || (_cache[8] = ($event: any) => (_unref($v).confirmPassword.$touch())),
                    placeholder: "Re-enter your password"
                  }, null, 544), [
                    [
                      _vModelText,
                      confirmPassword.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                (_unref($v).confirmPassword.$invalid && _unref($v).confirmPassword.$dirty)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_20, " Passwords do not match "))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_n_button, {
                variant: "primary",
                disabled: _unref($v).$invalid,
                onClick: register
              }, {
                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                  _createTextVNode(" Register", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _cache[22] || (_cache[22] = _createElementVNode("p", { class: "help" }, [
              _createTextVNode(" By clicking this button, you agree to Netcall's "),
              _createElementVNode("a", {
                href: "https://www.netcall.com/privacy-statement",
                target: "_blank"
              }, "Privacy Policy")
            ], -1))
          ]))
        : _createCommentVNode("", true),
      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "sidebar__footer" }, [
        _createElementVNode("div", { class: "netcall-logo" })
      ], -1))
    ])
  ]))
}
}

})